export default "__VITE_ASSET__DKM$EUKM__"